/** shiftnews.com and shiftntp.com, apex or any subdomain, nothing that merely contains the word. */
const SHIFT_HOSTS = /(^|\.)shift(news|ntp)\.com$/i
const SHIFT_NTP_HOSTS = /(^|\.)shiftntp\.com$/i

export function isShiftHost(hostname: string): boolean {
  return SHIFT_HOSTS.test(hostname)
}

export function isShiftNtpHost(hostname: string): boolean {
  return SHIFT_NTP_HOSTS.test(hostname)
}

/**
 * Whether the visitor asked for a shift domain, which is what picks the Yahoo
 * home layout. useRequestURL reads the request on the server and
 * window.location in the browser, so a server render answers with the host the
 * visitor used instead of deciding the layout without one and having the
 * browser swap it after hydration.
 */
export function isShift(): boolean {
  return isShiftHost(useRequestURL().hostname)
}
